import { useExternalNS } from '../../hooks/useExternalNS.js';
import { projectSettings } from '../../ProjectSettings.js';
const YMAPS_NAMESPACE = 'ymaps';
export const useYandexMaps = () => {
    const url = `https://api-maps.yandex.ru/2.1/?apikey=${projectSettings.YANDEX_MAP_API_KEY || ''}&lang=ru_RU`;
    return useExternalNS(YMAPS_NAMESPACE, url, false);
};
//# sourceMappingURL=useYandexMaps.js.map